/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Actions/InputValidationActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { ActionCreatorBase, Action } from "DistributedTask/Flux/Actions";
import { InputDetails, InputMetadata } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { InputValidationActions } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/InputValidationActions";

export class InputValidationActionCreator extends ActionCreatorBase {
    constructor(context: IVssPageContext) {
        super();
    }

    public initialize(instanceId: string): void {
        this._actions = ActionsHubManager.GetActionsHub<InputValidationActions>(InputValidationActions, instanceId);
    }

    public static getKey(): string {
        return "InputValidationActionCreatorKey";
    }

    public addInputs(inputDetailsList: InputDetails[]): void {
        this._actions.addInputs.invoke(inputDetailsList);
    }

    public removeInputs(inputIds: string[]): void {
        this._actions.removeInputs.invoke(inputIds);
    }

    public validateInputState(inputId: string, value: any, isUpdate: boolean): void {
        const inputMetadata: InputMetadata = {
            inputId: inputId,
            value: value,
            isUpdate: isUpdate,
            errorMessage: ""
        };
        this._actions.validateInputState.invoke(inputMetadata);
    }

    public setInputError(inputId: string, errorMessage: string): void {
        const inputMetadata: InputMetadata = {
            inputId: inputId,
            errorMessage: errorMessage,
            value: undefined,
            isUpdate: undefined
        };
        this._actions.setInputError.invoke(inputMetadata);
    }

    private _actions: InputValidationActions;
}
